import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { ClientService } from "../../component/services/client.service";
import CsrReportTable from "../../component/table/CsrReportTable";
import { faRefresh, faUserCircle } from "@fortawesome/free-solid-svg-icons";
import TablePaginationComponent from "../../component/table/TablePagination";
import moment from "moment";
import DownloadCsv from "../../component/DownloadCsv";
import { VerificationProcessEnum } from "../../component/enum/VerficationProcess.enum";
import FiltersComponent, {
  FilterOption,
} from "../../component/Filters/FiltersComponent";
import StatsCard from "../../component/Cards/StatsCard";
import { useTheme } from "../../theme/useTheme";
import { ClientServiceV2 } from "../../component/services/client.service.v2";

const BiometricNotmatched = () => {
  const { colors, colorSchemes } = useTheme();
  const [selectValue, setSelectValue] = useState<any>();
  const [shifts, setShifts] = useState<any>();
  const [verificationData, setVerificationData] = useState<any>();
  const [examName, setExamName] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<any>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [data, setData] = useState<any>();
  

  const [selectedFilters, setSelectedFilters] = useState<{
    states: FilterOption[];
    zones: FilterOption[];
    districts: FilterOption[];
    centers: FilterOption[];
    courses?: FilterOption[];
  }>({
    states: [],
    zones: [],
    districts: [],
    centers: [],
    courses: [],
  });

  const handleFiltersChange = (filters: any) => {
    setSelectedFilters(filters);
  };

  const getAllShift = async () => {
    await ClientService.getAllShifts()
      .then((res) => {
        if (res.status === 200) {
          setExamName(res.data.name);
          setShifts(
            res.data.shifts.map((data: any) => {
              return {
                label:
                  data.shiftName +
                  " - " +
                  moment(data.startTime).format("DD MMM YYYY"),
                value: data._id,
                startTime: data.startTime,
                endTime: data.endTime,
              };
            })
          );
        }
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  const getVerificationData = async () => {
    if (!selectValue) {
      toast.error("Please select shift first");
      return;
    }
    setLoading(true);
    // const payload = {
    //     state: selectedStates?.map((data: any) => data?.value),
    //     city: selectedDistricts?.map((data: any) => data?.value),
    //     zone: selectedZones?.map((data: any) => data?.value),
    //     centerId: selectedCenters?.map((data: any) => data?.value),
    // }
    let payload = {};

    if (selectedFilters.states?.length > 0) {
      payload = {
        ...payload,
        state: selectedFilters.states?.map((data: any) => data?.value),
      };
    }
    if (selectedFilters.districts?.length > 0) {
      payload = {
        ...payload,
        city: selectedFilters.districts?.map((data: any) => data?.value),
      };
    }
    if (selectedFilters.zones?.length > 0) {
      payload = {
        ...payload,
        zone: selectedFilters.zones?.map((data: any) => data?.value),
      };
    }
    if (selectedFilters.centers?.length > 0) {
      payload = {
        ...payload,
        centerId: selectedFilters.centers?.map((data: any) => data?.value),
      };
    }
    if (selectedFilters.courses && selectedFilters.courses?.length > 0) {
      payload = {
        ...payload,
        courseName: selectedFilters.courses?.map((data: any) => data?.value),
      };
    }
    await ClientServiceV2.getBiometricMismatch(
      selectValue,
      pageNumber,
      pageSize,
      payload
    )
      .then((res) => {
        if (res.status === 200) {
          setVerificationData(res.data?.data?.verification);
          setTotalCount(res.data?.data?.total_count);
          setData({
            total:res.data?.data?.total_count,
            distinct:res.data?.data.total_distinct


          });
         
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data);
      })
      .finally(() => setLoading(false));
  };
  console.log(totalCount,"total")
  console.log(data,"data")

  const finger_name = [
    { label: "Thumb", value: "thumb" },
    { label: "Index Finger", value: "index_finger" },
    { label: "Middle Finger", value: "middle_finger" },
    { label: "Ring Finger", value: "ring_finger" },
    { label: "Little Finger", value: "little_finger" },
  ];

  function createCSVData() {
    try {
      const csvData = verificationData.map((data: any) => {
        let f1 = data?.verificationDetails?.find(
          (detail: any) => detail?.method === "fingerprint"
        );
        let f2 = data?.verificationDetails?.find(
          (detail: any) => detail?.method === "fingerprint2"
        );
        let gps = data?.verificationDetails?.find(
          (detail: any) => detail?.method === "gps"
        );
        let selectedShift = shifts?.find(
          (shift: any) => shift?.value === selectValue
        );

        return {
          Exam: data?.["Exam Name"],
          Shift: selectedShift?.label,
          Date: moment(selectedShift?.startTime).format("DD-MM-YYYY"),
          "Candidate Roll No.": data?.["Roll No."],
          "Candidate Name": data?.["Candidate Name"],
          "Biometric Operator Name": data?.["Biometric Operator Name"],
          "Biometric Operatic ID": data?.["Biometric Operator Id"],
          State: data?.["State"],
          Division: data?.["Zone"],
          District: data?.["District"],
          "Venue ID": data?.["Center"],
          "Venue Name": data?.["Center Name"],
          "Live Image": data?.["Live Photo"] ? "Captured" : "Not Captured",
          Facial: data?.verificationDetails?.find(
            (detail: any) => detail?.method === VerificationProcessEnum.Facial
          )?.value,
          "Right Fingerprint": f1?.value
            ? f1.value +
              (f2?.value !== "Exception"
                ? " - " +
                  (f1?.remarks
                    ? finger_name?.find(
                        (data: any) =>
                          data?.value === JSON.parse(f1.remarks)?.fingersData
                      )?.label || "Thumb"
                    : "Thumb")
                : "")
            : "",

          "Left Fingerprint": f2?.value
            ? f2.value +
              (f2.value !== "Exception"
                ? " - " +
                  (f2?.remarks
                    ? finger_name?.find(
                        (data: any) =>
                          data?.value === JSON.parse(f2.remarks)?.fingersData
                      )?.label || "Thumb"
                    : "Thumb")
                : "")
            : "",
          GPS: gps?.value ? gps.value : "",
          "Registered At": data?.["Registered At"],
        };
      });
      return csvData;
    } catch (e) {
      console.log(e);
      return [];
    }
  }

  useEffect(() => {
    if (selectValue) {
      setVerificationData([]);
      getVerificationData();
    }
  }, [pageNumber, pageSize, selectedFilters]);

  useEffect(() => {
    getAllShift();
  }, []);

  return (
    <>
      <Row className="mt-5 text-left">
        <Col md={8}>
          <h4 className="mt-3 fw-bold" style={{ color: colors.primary.main }}>Biometric Mismatch</h4>
        </Col>
        <Col md={4}>
          <Form.Label className="fw-bold" style={{ color: colors.text.secondary }}>Select Shift</Form.Label>
          <Select
            options={shifts}
            placeholder="Select Shifts"
            onChange={(e: any) => {
              setSelectValue(e?.value);
            }}
            isClearable
            value={
              selectValue
                ? shifts.find((shift: any) => shift.value === selectValue.value)
                : null
            }
            styles={{
              control: (base, state) => {
                const rgbColor = colors.primary.main.replace('#', '');
                const r = parseInt(rgbColor.substring(0, 2), 16);
                const g = parseInt(rgbColor.substring(2, 4), 16);
                const b = parseInt(rgbColor.substring(4, 6), 16);
                return {
                  ...base,
                  borderColor: state.isFocused ? colors.primary.main : colors.border.secondary,
                  backgroundColor: colors.background.primary,
                  boxShadow: state.isFocused ? `0 0 0 3px rgba(${r}, ${g}, ${b}, 0.1)` : 'none',
                  borderRadius: '0.5rem',
                  minHeight: '44px',
                  transition: 'all 0.3s ease',
                  '&:hover': { borderColor: colors.primary.main }
                };
              },
              input: (base) => ({
                ...base,
                color: colors.text.primary
              }),
              placeholder: (base) => ({
                ...base,
                color: colors.text.muted
              }),
              singleValue: (base) => ({
                ...base,
                color: colors.text.primary,
                fontWeight: 500
              }),
              option: (base, state) => ({
                ...base,
                backgroundColor: state.isSelected ? colors.primary.main : state.isFocused ? colors.background.secondary : colors.background.primary,
                color: state.isSelected ? colors.background.primary : colors.text.primary,
                padding: '0.75rem 1rem',
                fontWeight: state.isSelected ? 600 : 500,
                transition: 'all 0.2s ease'
              }),
              menuList: (base) => ({
                ...base,
                paddingTop: 0,
                paddingBottom: 0
              }),
              menu: (base) => ({
                ...base,
                backgroundColor: colors.background.primary,
                border: `1px solid ${colors.border.secondary}`,
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                borderRadius: '0.75rem',
                marginTop: '0.5rem'
              })
            }}
          />
        </Col>
      </Row>

      {verificationData?.length > 0 && (
        <DownloadCsv
          headers={[
            "Exam",
            "Shift",
            "Date",
            "Candidate Roll No.",
            "Candidate Name",
            "Center Inv Id",
            "Operator Name",
            "State",
            "Division",
            "District",
            "Venue ID",
            "Venue Name",
            "Live Image",
            "Facial",
            "Right Fingerprint",
            "Left Fingerprint",
            "GPS",
            "Registered At",
          ]}
          createCsv={() => {
            return createCSVData();
          }}
          fileName="center-report"
        />
      )}

      <FiltersComponent
        selectedShift={selectValue}
        onFiltersChange={handleFiltersChange}
        showExamFilters={true}
      />
      <Row className="d-flex mt-4 mb-4 gap-3">
        <Col md={5} className="mb-3">
          <StatsCard
            title="Total Count"
            value={data?.total || 0}
            icon={faUserCircle}
            iconColor="primary"
            valueColor="primary"
          />
        </Col>
        <Col md={5} className="mb-3">
          <StatsCard
            title="Total Distinct"
            value={data?.distinct|| 0}
            icon={faUserCircle}
            iconColor="primary"
            valueColor="primary"
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CsrReportTable
            data={verificationData}
            pageNumber={pageNumber}
            pageSize={pageSize}
            loading={loading}
            reload={getVerificationData}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <TablePaginationComponent
            currentPage={pageNumber}
            itemsCount={totalCount}
            itemsPerPage={pageSize}
            setItemsPerPage={(e: any) => setPageSize(e)}
            setCurrentPage={setPageNumber}
          />
        </Col>
      </Row>
    </>
  );
};

export default BiometricNotmatched;
